import { useOpenCitationDocument } from 'stores/openCitationDocumentStore';

// Shared by the citation viewer (sliding in from the left) and the drawer it opens beside, which
// shrinks to the remaining width so the two sit side by side instead of overlapping. Kept out of the
// viewer module so the drawer can read it without pulling in react-pdf.
export const CITATION_VIEWER_WIDTH = 'clamp(420px, 50vw, 880px)';

// Never wider than the drawer is on its own, and never so narrow it stops being usable: on a small
// screen the viewer overlaps it instead.
export const BESIDE_CITATION_VIEWER_WIDTH = `clamp(360px, calc(100vw - ${CITATION_VIEWER_WIDTH}), min(92vw, 960px))`;

/**
 * The width for a drawer that hosts citations: `width` on its own, narrowed beside the citation viewer
 * while a document is open. Read in the component that sizes the drawer, which is not necessarily the
 * one that renders the viewer (`useCitationViewer`), so it follows the shared open-document store.
 */
export function useBesideCitationViewerWidth<T extends string | undefined>(width: T): string | T {
  return useOpenCitationDocument() !== null ? BESIDE_CITATION_VIEWER_WIDTH : width;
}
